<template lang="pug">
.frow
  .frow.column-start.mb-25
    div(v-if="!printOut")
      h2 Potential Guides,
      p
        | We ask these questions with the intent of getting to know you better so we can create a
        | profile to help you connect with the right Young Adults. Not all of this information will make it
        | into your digital profile, but our Young Adult Team will be able to make better referrals and
        | more effectively advertise our Guides upon completion of this questionnaire.
    FamilyInformation(:user.sync="user" :printOut="printOut")
    BasicInformation(:user.sync="user" :printOut="printOut")
    GuideInformation(:user.sync="user" :printOut="printOut")
    VButton(
      v-if="!printOut"
      text="Submit Guide Form"
      @click.native="$emit('save')"
    )

</template>
<script>
import FamilyInformation from "@/new-components/GuideForm/FamilyInformation";
import BasicInformation from "@/new-components/GuideForm/BasicInformation";
import GuideInformation from "@/new-components/GuideForm/GuideInformation";
export default {
  name: "guide-form",
  components: {
    FamilyInformation,
    BasicInformation,
    GuideInformation
  },
  props: {
    user: {
      type: Object
    },
    printOut: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({})
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.label {
  font-size: 0.8rem;
}
</style>
